import {
  LearnersStudentPreferencesSubjectPreferenceSet,
  LearnersStudentPreferencesSubjectPreferenceSetWithTAMSTrait,
  LearnersStudentPreferencesSubjectPreferenceSetAllTrait,
  LearnersStudentPreferencesPreferenceStudent,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type EditPageProps = {
  preferences?: Array<
    LearnersStudentPreferencesSubjectPreferenceSet &
      LearnersStudentPreferencesSubjectPreferenceSetAllTrait
  >
  student: LearnersStudentPreferencesPreferenceStudent
  school_id: string
  student_id: string
  added_preference_id: string | null
}
export const useEditProps = () => useProps<EditPageProps>()

export type ShowPageProps = {
  preferences: Array<
    LearnersStudentPreferencesSubjectPreferenceSet &
      LearnersStudentPreferencesSubjectPreferenceSetWithTAMSTrait
  >
  student: LearnersStudentPreferencesPreferenceStudent
}
